import { getToken, returnError } from './helperFunc';
import {
	getBillGroupAction,
	addBillGroupAction,
	assignBillGroupAction,
	editBillGroupAction,
} from './requestEndpoints';

import { LOGOUT_SUCCESS } from './userReducer';

const SET_LOADING_BILL_GROUP = 'SET_LOADING_BILL_GROUP';
const CLEAR_ERROR_BILL_GROUP = 'CLEAR_ERROR_BILL_GROUP';

const ADD_BILL_GROUP_SUCCESS = 'ADD_BILL_GROUP_SUCCESS';
const ADD_BILL_GROUP_FAIL = 'ADD_BILL_GROUP_FAIL';

const ASSIGN_BILL_GROUP_SUCCESS = 'ASSIGN_BILL_GROUP_SUCCESS';
const ASSIGN_BILL_GROUP_FAIL = 'ASSIGN_BILL_GROUP_FAIL';

const UPDATE_BILL_GROUP_SUCCESS = 'UPDATE_BILL_GROUP_SUCCESS';
const UPDATE_BILL_GROUP_FAIL = 'UPDATE_BILL_GROUP_FAIL';

const GET_BILL_GROUPS_SUCCESS = 'GET_BILL_GROUPS_SUCCESS';
const GET_BILL_GROUPS_FAIL = 'GET_BILL_GROUPS_FAIL';

export const getBillGroupList = (outletId, operatorId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_BILL_GROUP });
		dispatch({ type: SET_LOADING_BILL_GROUP });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await getBillGroupAction(outletId, operatorId, token);

		dispatch({ type: GET_BILL_GROUPS_SUCCESS, payload: data });
	} catch (error) {
		dispatch({
			type: GET_BILL_GROUPS_FAIL,
			payload: returnError(error),
		});
	}
};

export const addBillGroup = (newBillGroup) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_BILL_GROUP });
		dispatch({ type: SET_LOADING_BILL_GROUP });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await addBillGroupAction(newBillGroup, token);

		dispatch({ type: ADD_BILL_GROUP_SUCCESS, payload: data.data || data });
	} catch (error) {
		dispatch({ type: ADD_BILL_GROUP_FAIL, payload: returnError(error) });
	}
};

export const assignBillGroup = (billGroupData) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_BILL_GROUP });
		dispatch({ type: SET_LOADING_BILL_GROUP });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await assignBillGroupAction(billGroupData, token);

		dispatch({ type: ASSIGN_BILL_GROUP_SUCCESS, payload: data.data || data });
		return true;
	} catch (error) {
		dispatch({
			type: ASSIGN_BILL_GROUP_FAIL,
			payload: returnError(error),
		});
		return false;
	}
};

export const updateBillGroup = (updateData) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_ERROR_BILL_GROUP });
		dispatch({ type: SET_LOADING_BILL_GROUP });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await editBillGroupAction(updateData, token);

		dispatch({ type: UPDATE_BILL_GROUP_SUCCESS, payload: data.data || data });
		return true;
	} catch (error) {
		dispatch({
			type: UPDATE_BILL_GROUP_FAIL,
			payload: returnError(error),
		});
		return false;
	}
};

const initialState = {
	billGroups: [],
	billGroup: null,
	billGroupUpdated: null,
	assigned: null,
	loading: false,
	error: null,
	machineTrial: null,
	outletStatus: null,
};

const billGroupReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_LOADING_BILL_GROUP:
			return {
				...state,
				loading: true,
				billGroup: null,
				billGroupUpdated: null,
				assigned: null,
			};

		case CLEAR_ERROR_BILL_GROUP:
			return {
				...state,
				error: null,
			};

		case GET_BILL_GROUPS_SUCCESS:
			return {
				...state,
				billGroups: action.payload.data || action.payload,
				machineTrial: action.payload.machineTrial || null,
				outletStatus: action.payload.outletStatus || null,
				loading: false,
			}

		case GET_BILL_GROUPS_FAIL:
			return {
				...state,
				error: action.payload,
				loading: false,
			};

		case ADD_BILL_GROUP_SUCCESS:
			return {
				...state,
				billGroup: action.payload,
				loading: false,
			};

		case ADD_BILL_GROUP_FAIL:
			return {
				...state,
				error: action.payload,
				loading: false,
			};

		case ASSIGN_BILL_GROUP_SUCCESS:
			return {
				...state,
				assigned: action.payload,
				loading: false,
			};

		case ASSIGN_BILL_GROUP_FAIL:
			return {
				...state,
				error: action.payload,
				loading: false,
			};

		case UPDATE_BILL_GROUP_SUCCESS:
			return {
				...state,
				billGroupUpdated: action.payload,
				loading: false,
			};

		case UPDATE_BILL_GROUP_FAIL:
			return {
				...state,
				error: action.payload,
				loading: false,
			};

		case LOGOUT_SUCCESS:
			return initialState;

		default:
			return state;
	}
};

export default billGroupReducer;
